export default __webpack_public_path__ + "static/media/dirt.c82951bd.png";